export type NativeInvoiceWorkspaceStep = "details" | "send";

export interface NativeInvoiceWorkspaceStepDefinition {
    readonly id: NativeInvoiceWorkspaceStep;
    readonly statusLabel: string;
}

export const NATIVE_INVOICE_WORKSPACE_STEPS: readonly NativeInvoiceWorkspaceStepDefinition[] =
    [
        { id: "details", statusLabel: "Create invoice" },
        { id: "send", statusLabel: "Send email" },
    ];

// Templates (create and edit) are a single-step workflow: design and field
// settings live in collapsible sections of the details panel.
export const NATIVE_INVOICE_TEMPLATE_WORKSPACE_STEPS: readonly NativeInvoiceWorkspaceStepDefinition[] =
    [{ id: "details", statusLabel: "Template details" }];
